import React, { useState, useEffect } from "react";
import CommonModal from "../common/CommonModal";
import "./popup.less";
import { BASE_URL } from "../../constants/Common";
import Slider from "react-slick";
import { GET_EVENTS } from "../../constants/apiConstant";
import UtilService from "../../services/util";

const PopupBanner = (props) => {
  const [visible, setVisible] = useState(true);
  const [PopupPageData, setPopupPageData] = useState(props.PopupPageData);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    adaptiveHeight: true,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
  };

  const onClose = () => {
    setVisible(false);
  };

  return (
    <CommonModal
      modalSize="fixSize popupBanner"
      visible={visible}
      handleCancel={onClose}
    >
      <div className="bannerpopupImg">
        <Slider {...settings}>
          {PopupPageData && PopupPageData.length > 0 ? (
            PopupPageData.map((f, index) => {
              return (
                <div key={index} className="popupImageSlider">
                  {["mp4", "mkv", "wmv"].includes(
                    f.split(".").pop().toLowerCase()
                  ) ? (
                    <div className="topbannerImage">
                      <video autoPlay loop>
                        <source src={BASE_URL + f}></source>
                      </video>
                    </div>
                  ) : (
                    <div className="topbannerImage">
                      <img src={BASE_URL + f} alt="banner" />
                    </div>
                  )}
                </div>
              );
            })
          ) : (
            <></>
          )}
        </Slider>
      </div>
    </CommonModal>
  );
};
export default PopupBanner;
